import React from "react";

const CustomTitleTerms = ({ title, first }) => {
  return (
    <h2
      className={`${
        first ? "mb-2 md:mb-3" : "mt-4 mb-2 md:mt-6 md:mb-3 "
      }  text-xl font-bold text-black  lg:text-3xl`}
    >
      {title}
    </h2>
  );
};

export default CustomTitleTerms;
